// extracted by css-extract-rspack-plugin
export default {"container":"FieldCheckBox_container__7Ifzx"};